import React from 'react'
import ServicesHeader from '../services/servicesHeader'
import { Box, Typography, Grid, Divider } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import InstagramIcon from '@mui/icons-material/Instagram'
import ContactForm from './contactForm'
import background from '../_content/paving4.webp'

const ContactPage = () => {
  return (
    <>
      <ServicesHeader background={background} text="Contact Us" />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />
        <Box sx={{ backgroundColor: '#8FAA30', mx: 'auto', padding: 3}}>
          <Typography  sx={{color: 'white', textAlign: 'center', fontSize: '1.5rem' }}>
            Get in touch today for a free quote or to answer any queries.
          </Typography>
        </Box>
      <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />

      {/* CONTACT DETAILS */}
      <Box sx={{ textAlign: 'center', py: 4, px: 2 }}>
        <Typography
          align="center"
          variant="h4"
          sx={{
            color: 'white',
            fontWeight: 700,
            mb: 3,
          }}
        >
          Contact Details
        </Typography>

     <Grid container spacing={3} justifyContent="center">
        {/* PHONE */}
        <Grid item xs={12} sm={6} md="auto">
          <Box
            component="a"
            href="tel:+447580198722"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 3,
              py: 2,
              borderRadius: '12px',
              border: '1px solid rgba(255,255,255,0.4)',
              background: 'rgba(255,255,255,0.05)',
              backdropFilter: 'blur(6px)',
              textDecoration: 'none',
              transition: 'all 0.25s ease',

              '&:hover': {
                background: 'rgba(255,255,255,0.1)',
                transform: 'translateY(-3px)',
              },
            }}
          >
            <PhoneIcon sx={{ color: '#8FAA30', fontSize: 26 }} />
            <Typography sx={{ color: 'white', fontWeight: 500 }}>
              +44 7580 198722
            </Typography>
          </Box>
        </Grid>

        {/* EMAIL */}
        <Grid item xs={12} sm={6} md="auto">
          <Box
            component="a"
            href="mailto:info@read-landscaping.com"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 3,
              py: 2,
              borderRadius: '12px',
              border: '1px solid rgba(255,255,255,0.4)',
              background: 'rgba(255,255,255,0.05)',
              backdropFilter: 'blur(6px)',
              textDecoration: 'none',
              transition: 'all 0.25s ease',

              '&:hover': {
                background: 'rgba(255,255,255,0.1)',
                transform: 'translateY(-3px)',
              },
            }}
          >
            <EmailIcon sx={{ color: '#8FAA30', fontSize: 26 }} />
            <Typography sx={{ color: 'white', fontWeight: 500 }}>
              info@read-landscaping.com
            </Typography>
          </Box>
        </Grid>

        {/* INSTAGRAM */}
        <Grid item xs={12} sm={6} md="auto">
          <Box
            component="a"
            href="https://instagram.com/read_landscaping"
            target="_blank"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 3,
              py: 2,
              borderRadius: '12px',
              border: '1px solid rgba(255,255,255,0.4)',
              background: 'rgba(255,255,255,0.05)',
              backdropFilter: 'blur(6px)',
              textDecoration: 'none',
              transition: 'all 0.25s ease',

              '&:hover': {
                background: 'rgba(255,255,255,0.1)',
                transform: 'translateY(-3px)',
              },
            }}
          >
            <InstagramIcon sx={{ color: '#8FAA30', fontSize: 26 }} />
            <Typography sx={{ color: 'white', fontWeight: 500 }}>
              @read_landscaping
            </Typography>
          </Box>
        </Grid>
      </Grid>
      </Box>

      {/* FORM SECTION */}
      <Box>
        <ContactForm />
      </Box>
    </>
  )
}

export default ContactPage